// Guaranty Multi-Signer — HTTP transport for a loan's guaranty roster: read the
// roster (who's expected / who's in) and send guaranties (fan out one DocuSign
// envelope per Pending guarantor). Mirrors the backend DTOs in
// PhoenixCapital.Core/DTOs/PortfolioAdmin/GuarantyDtos.cs and the routes on
// PhoenixCapital.Api/Controllers/PortfolioAdmin/LoanGuarantiesController.cs.
// Hooks in @/hooks/portfolioAdmin/useGuaranties wrap these with TanStack Query.

import { api } from "@/api/client";

// --- Vocabulary --------------------------------------------------------------

export type GuarantySigningMode = "Embedded" | "Remote";

export type GuarantyStatus =
  | "Pending"
  | "Sent"
  | "Delivered"
  | "Signed"
  | "Filed"
  | "Declined"
  | "Voided";

// --- Shapes ------------------------------------------------------------------

export interface GuarantyRosterRow {
  id: string;
  guarantorPartyId: string;
  guarantorName: string;
  guarantorEmail: string;
  signingMode: GuarantySigningMode;
  status: GuarantyStatus;
  providerEnvelopeId: string | null;
  collectionItemId: string | null;
  stagedSubmissionId: string | null;
  filedDocumentId: string | null;
  sentAt: string | null;
  signedAt: string | null;
  filedAt: string | null;
}

export interface GuarantyRoster {
  loanId: string;
  rows: GuarantyRosterRow[];
  // How many rows a Send would fire (Pending rows).
  sendableCount: number;
}

// --- Transport ---------------------------------------------------------------

export const guarantiesApi = {
  forLoan: (loanId: string) =>
    api.get<GuarantyRoster>(`/portfolio-admin/loans/${loanId}/guaranties`),
  send: (loanId: string) =>
    api.post<GuarantyRoster>(`/portfolio-admin/loans/${loanId}/guaranties/send`, {}),
};
